import { motion } from "framer-motion";
import { ASSETS, PORTALS } from "@/data/content";
import { imgProps } from "@/lib/img";

export default function PortalVisual({ k, dimmed = false, onClick, testid, compact = false }) {
  const p = PORTALS[k];
  const logo = k === "park" ? ASSETS.parkLogo : ASSETS.royalLogo;
  const cardProps = imgProps(p.cardImg, compact ? "(max-width: 640px) 160px, 208px" : "(max-width: 640px) 240px, 320px");
  return (
    <motion.button
      type="button"
      data-testid={testid}
      onClick={onClick}
      whileHover={{ scale: 1.045, filter: "brightness(1.14)" }}
      whileTap={{ scale: 0.97 }}
      animate={
        dimmed
          ? { scale: 0.72, opacity: 0.45, x: k === "park" ? -64 : 64, filter: "brightness(0.8)" }
          : { scale: 1, opacity: 1, x: 0, filter: "brightness(1)" }
      }
      transition={{ type: "spring", stiffness: 260, damping: 25 }}
      className={`relative cursor-pointer outline-none group ${
        compact ? "w-40 h-60 sm:w-52 sm:h-72" : "w-60 h-[22rem] sm:w-80 sm:h-[30rem]"
      }`}
      style={{ borderRadius: "999px 999px 28px 28px" }}
      aria-label={p.name}
    >
      <div
        className="absolute inset-0 overflow-hidden border-2 shadow-[0_24px_60px_rgba(0,0,0,0.55)]"
        style={{
          borderRadius: "999px 999px 28px 28px",
          borderColor: p.border,
          boxShadow: `0 24px 60px rgba(0,0,0,0.55), inset 0 -60px 80px rgba(3,10,7,0.75), inset 0 20px 50px rgba(255,220,140,0.08)`,
        }}
      >
        <img
          {...cardProps}
          alt={p.name}
          className="w-full h-full object-cover"
          style={{ ...cardProps.style, objectPosition: p.cardPos }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />
      </div>
      <div className="absolute inset-x-3 bottom-4 flex flex-col items-center gap-2">
        <div
          className="glass rounded-2xl px-4 py-2.5 flex items-center gap-2.5 shadow-[0_8px_30px_rgba(0,0,0,0.45)]"
        >
          <img src={logo} alt={p.name} className="w-8 h-8 rounded-full object-cover bg-white" loading="lazy" decoding="async" />
          <div className="text-left">
            <div className="font-cinzel text-amber-100 text-sm sm:text-base leading-none">{p.name}</div>
            <div className="text-[10px] text-amber-200/70 mt-1 tracking-wide">Натисніть, щоб дізнатися більше</div>
          </div>
        </div>
      </div>
    </motion.button>
  );
}
